/* always open the page at the very top (no anchor / scroll restoration jumps) */
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
window.addEventListener('load', function(){ window.scrollTo(0, 0); });

/* hero gallery: native scroll-snap carousel, synced with the thumbnails */
(function(){
  var g=document.getElementById("gallery");
  var thumbs=document.getElementById("thumbs");
  var cap=document.querySelector(".shotcap");
  if(!g) return;
  function tEls(){ return thumbs ? thumbs.querySelectorAll(".thumb") : []; }
  function setActive(i){
    var t=tEls();
    for(var k=0;k<t.length;k++){ t[k].classList.toggle("on", k===i); }
    if(cap){ cap.style.display = i===0 ? "" : "none"; }
    if(t[i]){ t[i].scrollIntoView({inline:"center",block:"nearest",behavior:"smooth"}); }
  }
  function index(){ return g.clientWidth ? Math.round(g.scrollLeft / g.clientWidth) : 0; }
  var raf=0, last=0;
  g.addEventListener("scroll",function(){
    if(raf) return;
    raf=requestAnimationFrame(function(){ raf=0; var i=index(); if(i!==last){ last=i; setActive(i); } });
  },{passive:true});
  if(thumbs){
    thumbs.addEventListener("click",function(e){
      var th=e.target.closest(".thumb"); if(!th) return;
      var i=Array.prototype.indexOf.call(tEls(),th);
      if(i>=0) g.scrollTo({left:i*g.clientWidth,behavior:"smooth"});
    });
  }
  /* desktop: click-drag the image to scroll through the photos */
  var down=false,sx=0,sl=0,moved=false;
  g.addEventListener("pointerdown",function(e){
    if(e.pointerType!=="mouse") return;
    down=true;moved=false;sx=e.clientX;sl=g.scrollLeft;g.classList.add("dragging");
  });
  window.addEventListener("pointermove",function(e){
    if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>3) moved=true; g.scrollLeft=sl-dx;
  });
  window.addEventListener("pointerup",function(){
    if(!down) return; down=false; g.classList.remove("dragging");
    g.scrollTo({left:index()*g.clientWidth,behavior:"smooth"});
  });
  g.addEventListener("click",function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } },true);
})();

/* hero thumbnail rail: minimalist arrows + disable at the ends */
(function(){
  var rail=document.getElementById("thumbs"),
      prev=document.getElementById("thumbPrev"), next=document.getElementById("thumbNext");
  if(!rail||!prev||!next) return;
  function step(){ var c=rail.querySelector(".thumb"); return c ? c.offsetWidth+10 : 100; }
  function edges(){
    prev.disabled = rail.scrollLeft < 6;
    next.disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 6;
  }
  prev.addEventListener("click",function(){ rail.scrollLeft -= step()*2; });
  next.addEventListener("click",function(){ rail.scrollLeft += step()*2; });
  rail.addEventListener("scroll",edges,{passive:true});
  addEventListener("resize",edges); edges();
})();

/* tiers */
var tiers=document.getElementById("tiers"), cta=document.getElementById("cta");
var bbPrice=document.getElementById("bbPrice"), bbSub=document.getElementById("bbSub");
function priceOut(){
  var on=tiers.querySelector(".tier.on");
  var m=parseInt(on.dataset.m,10), b=parseInt(on.dataset.b,10);
  var total=parseInt(on.dataset.p,10)*m;
  cta.textContent="Try Risk-Free For 30 Days — £"+total;
  bbPrice.innerHTML="£"+(total/b).toFixed(2)+"<i>/each</i>";
  bbSub.textContent=on.querySelector(".tname").textContent+" · £"+total+" total";
}
tiers.addEventListener("click",function(e){
  var t=e.target.closest(".tier"); if(!t) return;
  [].forEach.call(this.children,function(c){c.classList.remove("on")});
  t.classList.add("on"); priceOut();
});
priceOut();


/* accordions */
document.querySelectorAll(".accbtn").forEach(function(b){
  b.addEventListener("click",function(){ b.parentElement.classList.toggle("open"); });
});

/* ingredient carousel */
(function(){
  var rail=document.getElementById("ingr"),
      prev=document.getElementById("ingPrev"), next=document.getElementById("ingNext");
  if(!rail) return;
  function step(){ var c=rail.querySelector(".ing"); return c ? c.offsetWidth+22 : 260; }
  function edges(){
    prev.disabled = rail.scrollLeft < 8;
    next.disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 8;
  }
  prev.addEventListener("click",function(){ rail.scrollLeft -= step()*2; });
  next.addEventListener("click",function(){ rail.scrollLeft += step()*2; });
  rail.addEventListener("scroll",edges,{passive:true});
  addEventListener("resize",edges);
  // start from the middle so the viewer can scroll either way to reach the edges
  function center(){ rail.scrollLeft=Math.max(0,(rail.scrollWidth-rail.clientWidth)/2); edges(); }
  requestAnimationFrame(center);
})();

/* reveal on scroll */
var io=new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
},{threshold:.12,rootMargin:"0px 0px -8% 0px"});
document.querySelectorAll(".rv,.strike").forEach(function(el){io.observe(el)});


/* add to cart + go straight to checkout (each tier maps to its own pack variant) */
function fbAddToCheckout(){
  var on=tiers.querySelector(".tier.on");
  var vid=on && on.dataset.variant;
  if(!vid) return;
  var id=parseInt(vid,10);
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:id,quantity:1}]})})
    .then(function(r){ if(!r.ok){ throw new Error('add failed'); } return r.json(); })
    .then(function(){ window.location.href='/checkout'; })
    .catch(function(){ window.location.href='/cart/'+id+':1'; });
}
cta.addEventListener("click",fbAddToCheckout);

/* the buy bar appears once the pricing list has scrolled by */
var bar=document.getElementById("buybar");
document.getElementById("bbBtn").addEventListener("click",fbAddToCheckout);
function barCheck(){
  var r=tiers.getBoundingClientRect();
  bar.classList.toggle("show", r.bottom < 40);
}
addEventListener("scroll",barCheck,{passive:true}); barCheck();

/* header: reveal on scroll-up, hide on scroll-down (always show near the top) */
(function(){
  var header=document.querySelector('.site'); if(!header) return;
  var lastY=window.scrollY||0, ticking=false;
  function update(){
    var y=window.scrollY||0;
    if(y<70) header.classList.remove('nav-hidden');
    else if(y>lastY+5) header.classList.add('nav-hidden');
    else if(y<lastY-5) header.classList.remove('nav-hidden');
    lastY=y; ticking=false;
  }
  window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(update); ticking=true; } },{passive:true});
})();

/* carousels: hide "Swipe for more" once scrolled to the end (experts + ingredients) */
(function(){
  function bind(rail){
    if(!rail) return;
    var host=rail.classList.contains('ingr')?rail.closest('.ingrwrap'):rail; if(!host) return;
    var hint=host.nextElementSibling;
    if(!hint||!hint.classList.contains('swipehint')) return;
    hint.style.transition='opacity .25s';
    function upd(){ hint.style.opacity=(rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-8)?'0':''; }
    rail.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd); upd();
  }
  bind(document.querySelector('.experts'));
  bind(document.getElementById('ingr'));
})();
